import styled from 'styled-components'
import Button from '@/components/ui/Button'
import Text from '@/components/common/Text'
import BaseTextArea from '@/components/common/BaseTextArea'
import { useTranslations } from 'next-intl'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: 100%;
  margin-top: 12px;
`

const FeedbackModalRow = styled.div`
  display: grid;
  grid-gap: 8px 12px;
  grid-template-columns: 1fr;
`

const FeedbackModalButton = styled(Button)`
  width: 100%;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`

const StepThree = ({
  formData,
  setFormData,
  onClickButtonHandler,
  closeModal,
  isLoading,
}) => {
  const t = useTranslations('creatives')

  return (
    <Wrapper>
      <FeedbackModalRow>
        <Text size="18">{t('suggestImprovements')}</Text>
        <BaseTextArea
          name="customField3"
          cols="30"
          rows="5"
          value={formData.improvementContent}
          onChange={(e) =>
            setFormData((prevData) => ({
              ...prevData,
              improvementContent: e.target.value,
            }))
          }
        />
      </FeedbackModalRow>
      <ButtonWrapper>
        <FeedbackModalButton
          onClick={onClickButtonHandler}
          isLoading={isLoading}
          filled
        >
          {t('sendFeedback')}
        </FeedbackModalButton>
        <FeedbackModalButton onClick={closeModal}>
          {t('btnSkip')}
        </FeedbackModalButton>
      </ButtonWrapper>
    </Wrapper>
  )
}
export default StepThree
